export const partnerIds = {
  qonto: 'qonto',
}

export const validPartners = [partnerIds.qonto]

export const partnerFunnelCategories = ['LI', 'CO', 'LE', 'FL', 'CY', 'EL']
